<template>
  <Modal :title="$t('global.dns-zone-srv-record-delete')" @close="close" @confirm="confirm">
    <template #body>
      <div>{{ $t("global.dns-zone-srv-record-delete-message") }}</div>
      <p class="text-center mt-4">{{ data.record.hostname }}</p>
    </template>
    <template #footer>
      <Btn class="mr-2" variant="light" type="button" :disabled="isSubmitting" @click="close">
        {{ $t("global.cancel") }}
      </Btn>
      <Btn variant="danger" @click="confirm" :loading="isSubmitting">
        {{ $t("global.delete") }}
      </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "DnsZoneSrvRecordDeleteModal",
  components: {
    Btn,
    Modal,
  },
  props: {
    data: Object,
  },
  setup(props, { emit, root }) {
    const isSubmitting = ref(false);
    const close = () => emit("close");

    const confirm = () => {
      isSubmitting.value = true;

      const { record } = props.data;

      store
        .dispatch("dnsZoneSrvRecords/delete", record.id)
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.dns-zone-srv-record-deleting-message", {
              name: record.hostname,
            }),
          });
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.dns-zone-srv-record-delete-error-message", {
              name: record.hostname,
            }),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      close,
      confirm,
      isSubmitting,
    };
  },
};
</script>
